import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import { borderRadius } from '../../../theme/theme';
import WorkflowCompletionSummary, {
  type WorkflowGuideCard,
} from './components/WorkflowCompletionSummary';
import type { WorkflowSummaryCard } from '../lib/mappingWorkspaceCompletionModel';

interface MappingSetupSummaryDialogProps {
  open: boolean;
  onClose: () => void;
  onOpenTour: () => void;
  onReturnToSetup?: () => void;
  chips: readonly string[];
  cards: readonly WorkflowSummaryCard[];
  guides: readonly WorkflowGuideCard[];
  activeGuideId: number;
  onSelectGuide: (id: number) => void;
}

const MappingSetupSummaryDialog: React.FC<MappingSetupSummaryDialogProps> = ({
  open,
  onClose,
  onOpenTour,
  onReturnToSetup,
  chips,
  cards,
  guides,
  activeGuideId,
  onSelectGuide,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      aria-labelledby="mapping-summary-window-title"
      PaperProps={{
        sx: {
          borderRadius: `${borderRadius.lg}px`,
          backgroundImage: 'none',
          overflow: 'hidden',
        },
      }}
    >
      <DialogContent sx={{ p: { xs: 1, md: 1.35 } }}>
        <Typography
          id="mapping-summary-window-title"
          sx={{
            position: 'absolute',
            width: '1px',
            height: '1px',
            p: 0,
            m: -1,
            overflow: 'hidden',
            clip: 'rect(0 0 0 0)',
            clipPath: 'inset(50%)',
            whiteSpace: 'nowrap',
            border: 0,
          }}
        >
          Mapping setup summary
        </Typography>
        <Box>
          <WorkflowCompletionSummary
            eyebrow="Setup summary"
            title="Readiness check"
            summary="Review what has been saved to this profile, what still needs attention, and whether the project is ready for PCF validation or export."
            chips={chips}
            cards={cards}
            guides={guides}
            activeGuideId={activeGuideId}
            onSelectGuide={onSelectGuide}
            actionLabel="Start mapping tour"
            onAction={onOpenTour}
          />
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          px: { xs: 1.25, md: 1.6 },
          pb: 1.25,
          pt: 0,
          justifyContent: 'space-between',
        }}
      >
        <Box>
          {onReturnToSetup && (
            <Button onClick={onReturnToSetup}>
              Return to setup
            </Button>
          )}
        </Box>
        <Button variant="contained" onClick={onClose}>
          Continue to mapping workspace
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MappingSetupSummaryDialog;
